import PsiSimpleTable from "./PsiSimpleTable.vue";
export { PsiSimpleTable };
